import { Component, ElementRef, ViewChild, HostListener } from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';
import { SocketService } from 'src/services/socket/socket.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Outlive service user';
  currentProperty: any;
  activeBanner: any = null;

  @ViewChild('appmodal') modal: any;
  constructor(public commonService: CommonService,
              public translate: TranslateService,
              private serviceManager: ServiceManagerService,
              private socketService: SocketService,
              public router: Router){
    this.socketService.setupSocketConnection()
    var userId = localStorage.getItem("userId")
    if(userId){
      this.socketService.join(userId, "SERVICE-USER")
    }
    this.initializeLanguage();
    this.loadActiveBanner();
    this.commonService.checkChatExist().then((exist: any) => {
      this.setSocketData()
      this.setWindowsHeight()
      window.addEventListener('resize', () => {
        this.setWindowsHeight()
      });
      if(exist){
          if(!localStorage.getItem("chatAccepts")){
            localStorage.setItem("chatAccepts", "true")
          }
      }
    })
  }
  

  ngOnInit(){
  }

  loadActiveBanner(): void {
    this.serviceManager.CallBackendServiceAPI('get_active_banner', {}, { showErrorMessage: false, showSuccessMessage: false, createLoaderAction: false }, false).subscribe((data: any) => {
      this.activeBanner = data.banner || null;
      // Recalculate --vh after banner renders so app-container height accounts for banner
      setTimeout(() => this.setWindowsHeight(), 0);
    });
  }
  ngOnDestroy() {
    this.socketService.disconnect();
  }

  /**
   * Sets windows height
   */
  setWindowsHeight(){
    const bannerEl = document.querySelector('.support-banner') as HTMLElement;
    const bannerHeight = bannerEl ? bannerEl.offsetHeight : 0;
    const vh = window.innerHeight - bannerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
  /**
   * Initializes language to English default
   */
  initializeLanguage() {
    var isExist = this.commonService.checkUserExists()
    if(isExist){
      var localLanguage = localStorage.getItem('language')
      if(localLanguage){
        this.translate.setDefaultLang(localLanguage);
        // this.commonService.navigateToPage('/home')
        return
      }
    }
    this.translate.setDefaultLang('en');
  }

  /**
   * Changes of routes
   */
  changeOfRoutes(){
    this.currentProperty = this.commonService.appProperties[this.router.url.split('?')[0].substring(1)]
  }

  setSocketData(){
    if(this.commonService.peerDetails){
      this.socketService.userDetails = {
        peerId: this.commonService.peerDetails.peerId,
        roomId: this.commonService.peerDetails.roomId,
        userId: localStorage.getItem("userId"),
        sessionId: this.commonService.peerDetails.sessionId,
        serviceUserName: this.commonService.peerDetails.service_user_dummy_name
      }
    }
  }

  @HostListener("document:visibilitychange", ['$event'])
  protected async onVisibilityChange() {
    if (!document.hidden && (!this.commonService.isChatShowed || /iPad|iPhone|iPod/.test(navigator.userAgent))) {
      this.commonService.checkChatExist().then((exist: any) => {
        if(exist && !localStorage.getItem("chatAccepts")){
          window.location.reload();
        }
      })
  }
    if (!document.hidden) {
      this.loadActiveBanner();
    }
  }
}
